export default __webpack_public_path__ + "static/media/as.d7e5fb58.png";